var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 15.1875C6.39583 14.1875 8.75 13.6875 11 13.6875C13.25 13.6875 15.5833 14.1875 18 15.1875C20.4583 16.1458 21.6875 17.4167 21.6875 19V21.6875H0.3125V19C0.3125 17.4167 1.52083 16.1458 3.9375 15.1875ZM14.75 9.4375C13.7083 10.4792 12.4583 11 11 11C9.54167 11 8.29167 10.4792 7.25 9.4375C6.20833 8.39583 5.6875 7.14583 5.6875 5.6875C5.6875 4.22917 6.20833 2.97917 7.25 1.9375C8.29167 0.854167 9.54167 0.3125 11 0.3125C12.4583 0.3125 13.7083 0.854167 14.75 1.9375C15.7917 2.97917 16.3125 4.22917 16.3125 5.6875C16.3125 7.14583 15.7917 8.39583 14.75 9.4375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.c8183d49a220be6f4cc648652b9912a2.svg";
export { ForwardRef as ReactComponent };